const enum ROLE {
  ROLE_MODERATOR = "ROLE_MODERATOR",
  ROLE_CONSULTANT = "ROLE_CONSULTANT",
  ROLE_CONSULTANT_CTV = "ROLE_CONSULTANT_CTV",
  ROLE_ADMIN = "ROLE_ADMIN",
}
export { ROLE };
